import { ReactComponent as AdultIcon } from "./adult-icon.svg";
import { ReactComponent as AirplanActiveIcon } from "./airplan-active.svg";
import { ReactComponent as AirplanInactiveIcon } from "./airplan-inactive.svg";
import { ReactComponent as AtripaIcon } from "./atripa-icon.svg";
import { ReactComponent as BedroomIcon } from "./bedroom-icon.svg";
import { ReactComponent as BusIcon } from "./bus.svg";
import { ReactComponent as ChildIcon } from "./child-icon.svg";
import { ReactComponent as DepartureIcon } from "./departure.svg";
import { ReactComponent as DetailsIcon } from "./details.svg";
import { ReactComponent as FamilyIcon } from "./family-icon.svg";
import { ReactComponent as FlightLineIcon } from "./flight-line.svg";
import { ReactComponent as Food4Icon } from "./food4.svg";
import { ReactComponent as FoodIcon } from "./food-icon.svg";
import { ReactComponent as genderIcon } from "./gender2.svg";
import { ReactComponent as HeartIcon } from "./heart.svg";
import { ReactComponent as HotelActiveIcon } from "./hotel-active.svg";
import { ReactComponent as HotelInactiveIcon } from "./hotel-inactive.svg";
import { ReactComponent as HotelWizardIcon } from "./hotel-wizard.svg";
import { ReactComponent as IntlAirplanActiveIcon } from "./intl-airplan-active.svg";
import { ReactComponent as IntlAirplanInactiveIcon } from "./intl-airplan-inactive.svg";
import { ReactComponent as IntlHotelActiveIcon } from "./intl-hotel-active.svg";
import { ReactComponent as IntlHotelInactiveIcon } from "./intl-hotel-inactive.svg";
import { ReactComponent as ItineraryWizardIcon } from "./itinerary-wizard.svg";
import { ReactComponent as linkdinIcon } from "./linkdin1.svg";
import { ReactComponent as LocationPinIcon } from "./location-pin.svg";
import { ReactComponent as ManIcon } from "./man-icon.svg";
import { ReactComponent as PassengerIcon } from "./passenger-icon.svg";
import { ReactComponent as PercentIcon } from "./percent.svg";
import { ReactComponent as percent2Icon } from "./percent2.svg";
import { ReactComponent as percentTIcon } from "./percent-t.svg";
import { ReactComponent as PreferencesWizardIcon } from "./preferences-wizard.svg";
import { ReactComponent as ReceiptIcon } from "./receipt.svg";
import { ReactComponent as SiteIcon } from "./site.svg";
import { ReactComponent as SmsIcon } from "./sms.svg";
import { ReactComponent as TickIcon } from "./tick.svg";
import { ReactComponent as TicketWizardIcon } from "./ticket-wizard.svg";
import { ReactComponent as TrainIcon } from "./train.svg";
import { ReactComponent as TriangleIcon } from "./triangle.svg";
import { ReactComponent as UserTypeIcon } from "./user-type.svg";
import { ReactComponent as WarningIcon } from "./warning.svg";
import { ReactComponent as WomanIcon } from "./woman-icon.svg";
import { ReactComponent as Bell } from "./bell.svg";
import { ReactComponent as Flash } from "./flash.svg";
import { ReactComponent as FranceFlag } from "./flag-for-flag-france.svg";
import { ReactComponent as GermanyFlag } from "./flag-for-flag-germany.svg";
import { ReactComponent as ItalyFlag } from "./flag-for-flag-italy.svg";
import { ReactComponent as RussiaFlag } from "./flag-for-flag-russia.svg";

export const Icons = {
    AdultIcon: AdultIcon,
    AirplanActiveIcon: AirplanActiveIcon,
    AirplanInactiveIcon: AirplanInactiveIcon,
    AtripaIcon: AtripaIcon,
    BedroomIcon: BedroomIcon,
    BusIcon: BusIcon,
    ChildIcon: ChildIcon,
    DepartureIcon: DepartureIcon,
    DetailsIcon: DetailsIcon,
    FamilyIcon: FamilyIcon,
    FlightLineIcon: FlightLineIcon,
    Food4Icon: Food4Icon,
    FoodIcon: FoodIcon,
    genderIcon: genderIcon,
    HeartIcon: HeartIcon,
    HotelActiveIcon: HotelActiveIcon,
    HotelInactiveIcon: HotelInactiveIcon,
    HotelWizardIcon: HotelWizardIcon,
    IntlAirplanActiveIcon: IntlAirplanActiveIcon,
    IntlAirplanInactiveIcon: IntlAirplanInactiveIcon,
    IntlHotelActiveIcon: IntlHotelActiveIcon,
    IntlHotelInactiveIcon: IntlHotelInactiveIcon,
    ItineraryWizardIcon: ItineraryWizardIcon,
    linkdinIcon: linkdinIcon,
    LocationPinIcon: LocationPinIcon,
    ManIcon: ManIcon,
    PassengerIcon: PassengerIcon,
    PercentIcon: PercentIcon,
    percent2Icon: percent2Icon,
    percentTIcon: percentTIcon,
    PreferencesWizardIcon: PreferencesWizardIcon,
    ReceiptIcon: ReceiptIcon,
    SiteIcon: SiteIcon,
    SmsIcon: SmsIcon,
    TickIcon: TickIcon,
    TicketWizardIcon: TicketWizardIcon,
    TrainIcon: TrainIcon,
    TriangleIcon: TriangleIcon,
    UserTypeIcon: UserTypeIcon,
    WarningIcon: WarningIcon,
    WomanIcon: WomanIcon,
    Bell: Bell,
    Flash: Flash,
    FranceFlag: FranceFlag,
    GermanyFlag: GermanyFlag,
    ItalyFlag: ItalyFlag,
    RussiaFlag: RussiaFlag,
};
